import classes from "./Loader.module.scss";

export const Loader = () => {
  return (
    <div className={classes.loaderWrapper}>
      <div className={classes.loader}>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  );
};
